var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M0 2.188a2.187 2.187 0 1 1 4.375 0v7.874a1.312 1.312 0 1 1-2.625 0V3.939a.438.438 0 0 1 .875 0v6.124a.438.438 0 0 0 .875 0V2.189a1.313 1.313 0 0 0-2.625 0v7.874a2.188 2.188 0 0 0 4.375 0V3.939a.438.438 0 0 1 .875 0v6.124a3.062 3.062 0 1 1-6.125 0z"
  })));
};
export default SvgAttachment;